export interface MovieItem {
  id: string;
  title: string;
  genre: string[];
  region: string;
  year: number;
  rating: number;
  poster: string;
  synopsis: string;
  cast: string[];
  director: string;
  duration: string;
  popularity: number;
}

export const movieGenres = ["剧情", "科幻", "喜剧", "动作", "悬疑", "爱情", "动画"];
export const movieRegions = ["中国大陆", "美国", "韩国", "日本", "中国香港"];
export const movieYears = [2026, 2025, 2024, 2023];

export const movieList: MovieItem[] = [
  {
    id: "city-of-echoes",
    title: "回声之城",
    genre: ["科幻", "剧情"],
    region: "中国大陆",
    year: 2026,
    rating: 9.2,
    poster:
      "https://readdy.ai/api/search-image?query=artistic%20futuristic%20city%20skyline%20with%20glowing%20orange%20neon%20lines%2C%20cinematic%20sci%20fi%20movie%20poster%20illustration%2C%20dramatic%20dusk%20atmosphere&width=600&height=900&seq=movie-01&orientation=portrait",
    synopsis:
      "在一座被记忆记录系统覆盖的未来城市里，一名声音工程师意外发现了被抹除的片段，从而踏上一段追寻真相的旅程。影片以细腻的情感与宏大的世界观，探讨科技与人性的边界。",
    cast: ["林知远", "苏格", "陈默", "周桐"],
    director: "顾清和",
    duration: "132 分钟",
    popularity: 98,
  },
  {
    id: "summer-in-tokyo",
    title: "东京的夏天",
    genre: ["爱情", "剧情"],
    region: "日本",
    year: 2025,
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=nostalgic%20summer%20street%20in%20japan%20with%20warm%20sunset%20light%20and%20bicycle%20silhouette%2C%20romantic%20film%20poster%20illustration%2C%20soft%20melancholic%20tone&width=600&height=900&seq=movie-02&orientation=portrait",
    synopsis:
      "两个在城市里各自漂泊的年轻人，在一个夏天相遇又错过。影片用缓慢的节奏记录了一段没有结局的感情，也记录了一座城市最温柔的季节。",
    cast: ["夏川结衣", "佐藤岚", "小林望"],
    director: "森田悠",
    duration: "118 分钟",
    popularity: 82,
  },
  {
    id: "laugh-out-loud",
    title: "笑到最后",
    genre: ["喜剧"],
    region: "中国大陆",
    year: 2026,
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=playful%20colorful%20abstract%20shapes%20with%20orange%20and%20yellow%20tones%2C%20fun%20comedy%20movie%20poster%20illustration%2C%20bright%20energetic%20mood&width=600&height=900&seq=movie-03&orientation=portrait",
    synopsis:
      "一个濒临倒闭的喜剧俱乐部，一群不肯认输的普通人，为了守住舞台闹出了一连串笑话。笑着笑着，他们找到的其实是对生活的热爱。",
    cast: ["王大鹏", "李圆圆", "赵小满"],
    director: "马小乐",
    duration: "104 分钟",
    popularity: 88,
  },
  {
    id: "the-last-witness",
    title: "最后一个目击者",
    genre: ["悬疑", "动作"],
    region: "中国香港",
    year: 2025,
    rating: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=noir%20rainy%20night%20alley%20with%20neon%20reflections%20and%20lone%20figure%2C%20moody%20thriller%20movie%20poster%20illustration%2C%20deep%20contrast&width=600&height=900&seq=movie-04&orientation=portrait",
    synopsis:
      "一桩尘封十年的旧案，唯一的目击者却坚称自己从未见过凶手。警探在层层迷雾中抽丝剥茧，真相远比想象中复杂。",
    cast: ["郑嘉豪", "何静文", "梁子轩"],
    director: "陈汉辉",
    duration: "126 分钟",
    popularity: 90,
  },
  {
    id: "star-voyage",
    title: "星际远航",
    genre: ["科幻", "动作"],
    region: "美国",
    year: 2026,
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=epic%20spaceship%20floating%20before%20a%20giant%20ringed%20planet%2C%20cinematic%20sci%20fi%20poster%20illustration%2C%20warm%20orange%20nebula%20tones&width=600&height=900&seq=movie-05&orientation=portrait",
    synopsis:
      "人类第一艘远航飞船踏上了寻找新家园的旅程。在漫长的星际跋涉中，船员们必须面对资源枯竭与人性的双重考验。",
    cast: ["Ethan Cole", "Maya Reyes", "Daniel Frost"],
    director: "Adam Sterling",
    duration: "144 分钟",
    popularity: 94,
  },
  {
    id: "spring-of-the-village",
    title: "村庄的春天",
    genre: ["剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 9.0,
    poster:
      "https://readdy.ai/api/search-image?query=golden%20wheat%20field%20at%20sunrise%20with%20distant%20mountain%20village%2C%20warm%20documentary%20style%20film%20poster%20illustration%2C%20hopeful%20tone&width=600&height=900&seq=movie-06&orientation=portrait",
    synopsis:
      "一位返乡的年轻人决定留在村里，用新的方式经营祖辈留下的土地。影片记录了一个普通村庄在时代变迁中的温暖故事。",
    cast: ["孙建国", "刘慧兰", "张春生"],
    director: "田禾",
    duration: "112 分钟",
    popularity: 76,
  },
  {
    id: "korean-mystery-night",
    title: "深夜の信号",
    genre: ["悬疑", "剧情"],
    region: "韩国",
    year: 2025,
    rating: 8.8,
    poster:
      "https://readdy.ai/api/search-image?query=lonely%20radio%20tower%20glowing%20at%20midnight%20with%20foggy%20forest%2C%20atmospheric%20korean%20thriller%20poster%20illustration%2C%20eerie%20warm%20tone&width=600&height=900&seq=movie-07&orientation=portrait",
    synopsis:
      "一名深夜电台主持人开始收到来自未来的神秘信号，每一段广播都与失踪案有关。她必须在下一个信号到来前拯救一个陌生人。",
    cast: ["金秀贤", "朴敏儿", "李正浩"],
    director: "崔东旭",
    duration: "121 分钟",
    popularity: 85,
  },
  {
    id: "little-cloud-adventure",
    title: "云朵朵历险记",
    genre: ["动画", "喜剧"],
    region: "中国大陆",
    year: 2026,
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=cute%20stylized%20cloud%20character%20floating%20over%20colorful%20hills%20at%20sunset%2C%20warm%20animated%20movie%20poster%20illustration%2C%20playful%20childlike%20mood&width=600&height=900&seq=movie-08&orientation=portrait",
    synopsis:
      "一朵不愿下雨的小云朵，为了寻找属于自己的使命踏上旅途。一路上它遇到了风、彩虹和各种各样奇妙的伙伴。",
    cast: ["配音：糖果", "配音：小石头", "配音：阿毛"],
    director: "吴星",
    duration: "95 分钟",
    popularity: 79,
  },
  {
    id: "the-chefs-table",
    title: "深夜食堂的故事",
    genre: ["剧情", "爱情"],
    region: "日本",
    year: 2024,
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=cozy%20small%20japanese%20restaurant%20at%20night%20with%20warm%20lamp%20light%2C%20heartwarming%20food%20film%20poster%20illustration%2C%20intimate%20tone&width=600&height=900&seq=movie-09&orientation=portrait",
    synopsis:
      "一家只在深夜营业的小餐馆，一位沉默的老板，每道菜背后都藏着一位客人的故事。食物与人心，在这里慢慢被治愈。",
    cast: ["山田太郎", "中村美咲", "高桥健"],
    director: "井上诚",
    duration: "108 分钟",
    popularity: 74,
  },
  {
    id: "code-red",
    title: "红色警戒线",
    genre: ["动作", "悬疑"],
    region: "美国",
    year: 2025,
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=explosive%20action%20scene%20with%20orange%20flames%20and%20flying%20debris%2C%20bold%20hollywood%20action%20poster%20illustration%2C%20high%20energy%20contrast&width=600&height=900&seq=movie-10&orientation=portrait",
    synopsis:
      "一支精英小队被派往执行一项几乎不可能完成的任务。随着行动推进，他们发现真正的威胁或许来自内部。",
    cast: ["Ryan Blake", "Sophia Lane", "Marcus Hill"],
    director: "Grace Whitmore",
    duration: "118 分钟",
    popularity: 83,
  },
  {
    id: "paper-plane",
    title: "纸飞机的约定",
    genre: ["爱情", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=paper%20plane%20flying%20over%20a%20sunlit%20schoolyard%20with%20autumn%20leaves%2C%20nostalgic%20romance%20film%20poster%20illustration%2C%20warm%20soft%20tone&width=600&height=900&seq=movie-11&orientation=portrait",
    synopsis:
      "两个童年约定好要用纸飞机保持联系的人，在分别多年后重新相遇。时间改变了他们，却没能改变那份最初的约定。",
    cast: ["林小夏", "方宇", "顾念"],
    director: "许南",
    duration: "106 分钟",
    popularity: 71,
  },
  {
    id: "mountain-patrol",
    title: "雪线之上",
    genre: ["动作", "剧情"],
    region: "中国大陆",
    year: 2026,
    rating: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=snow%20covered%20mountain%20peak%20with%20tiny%20climber%20silhouette%20under%20golden%20dawn%2C%20epic%20adventure%20movie%20poster%20illustration%2C%20awe%20inspiring%20tone&width=600&height=900&seq=movie-12&orientation=portrait",
    synopsis:
      "一支高山救援队在暴风雪中收到求救信号。面对随时可能发生的雪崩，他们必须做出最艰难的选择。",
    cast: ["高峰", "洛桑", "陈岩"],
    director: "韩雪峰",
    duration: "129 分钟",
    popularity: 87,
  },
];